import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import { UsersService } from 'app/pages/users/users.service';
import { ProvidersBillingService } from '../providers-billing-service.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { DomSanitizer } from '@angular/platform-browser';
import { _currencyFormat } from 'app/utils/trip2-query-builder/utils/helpers';
import { Subscription } from 'rxjs/Subscription';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { _downloadFileGenericIsExcel } from 'app/utils/helpers';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss']
})
export class PaymentsComponent implements OnInit, OnDestroy {

  @ViewChild('batchDetailModal') private batchModal: T2CardComponent;
  protected selectedProvider: any;
  protected providers = [];
  protected grid = <GridOptions> {};
  onFiltered: boolean;
  modalOpen = false;
  selectedBatchId: any;
  public subscriptions: Subscription[] = [];

  constructor(
    private userService: UsersService,
    private service: ProvidersBillingService,
    private loading: T2LoadingService,
    public sanitizer: DomSanitizer,
    public sweetAlertHelper: SweetAlertHelper
  ) {
    this.grid.columnDefs = this.getColumns();
    this.grid.onFilterChanged = (params) => {
      this.onFiltered = params.api['filterManager'].advancedFilterPresent;
    };

    // TODO Cargar Grid Vacia
    this.grid.onGridReady = () => {
      this.grid.api.setRowData([]);
    };
   }

  ngOnInit() {
    this.getProviders();
  }

  onChangeProvider() {
    this.getPaidBatchs();
  }

  /**
   * @name clearFilters
   * @description clear grid filters
   */
  clearFilters() {
    this.grid.api.setFilterModel(null);
    this.onFiltered = false;
  }

  /**
   * this get providers data from server
   */
  private getProviders() {
    this.subscriptions.push(this.userService.getProvidersForUser('&orderBy=true').subscribe(
      data => {
        if (data.length === 1) {
          this.selectedProvider = data[0].companyid;
        }
        this.providers = data;
      }
    ));
  }

  /**
   * this get batchs when user select a provider
   */
  private getPaidBatchs() {
    this.loading.show();
    if (this.selectedProvider) {
      this.subscriptions.push(this.service.getPaidBatchs(this.selectedProvider)
      .finally(() => {
        this.loading.hiden();
      })
      .subscribe(
        res => {
          this.grid.api.setRowData(res.data);
        }
      ));
    }
  }

  /**
   * this execute when user make souble click in the grid
   * @param event batch selected
   */
  openBatch(event) {
    this.selectedBatchId = event.data.paymentbatchid;
    this.batchModal.open();
  }

  /**
   * this execute when modal emit the events
   * @param event modal event
   */
  onModalEvents(event) {
    this.modalOpen = event.isOpen;

    if (!this.modalOpen) {
      this.selectedBatchId  = 0;
    }
  }

  /**
   * this format the amount cell
   */
  private amountCell = function(params) {
    return '$' + (params.value ? params.value : 0);
  };

  private getColumns() {
    return [
      {
        headerName: 'Batch Id',
        field: 'paymentbatchid',
        colId: 'paymentbatchid',
        width: 100,
        cellClass: ['text-a-center']
      },
      {
        headerName: 'Date Processed',
        field: 'processeddate',
        colId: 'processeddate',
        width: 200
      },
      {
        headerName: 'Trips',
        field: 'trips',
        colId: 'trips',
        cellClass: ['text-a-center'],
        width: 100
      },
      {
        headerName: 'Total Amount',
        field: 'totalamount',
        colId: 'totalamount',
        cellRenderer: this.amountCell,
        cellClass: ['text-a-right'],
        width: 150
      },
      {
        headerName: 'Report PDF',
        cellClass: ['text-a-center'],
        cellRenderer: () => {
          return `<button class="btn btn-primary"><i class="fa fa-download"></i></button>`;
        },
        colId: 'report',
        width: 110
      },
      {
        headerName: 'Report Excel',
        cellClass: ['text-a-center'],
        cellRenderer: () => {
          return `<button class="btn btn-primary"><i class="fas fa-file-excel"></i></button>`;
        },
        colId: 'reportEx',
        width: 110
      }
    ];
  }

  onGridReady(event) {
    event.api.sizeColumnsToFit();
  }

  downloadReport(event: any) {
    const isExcel = event.colDef.colId === 'report' ? false : true;
    if (event.colDef.colId === 'report' || event.colDef.colId === 'reportEx') {
      this.loading.show();
      this.subscriptions.push(this.service.getEopBatchReport(this.selectedProvider, event.data.paymentbatchid, isExcel).finally(
        () => { this.loading.hiden(); }
      ).subscribe({
        next: (response: any) => {
          _downloadFileGenericIsExcel(response, isExcel);
        },
        error: (err) => {
          this.sweetAlertHelper.captureException(err);
        },
        }
      ));
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/providers-billing/payments/payments.component.ts